module.exports = __webpack_public_path__ + "img/2.3c4cf8a6.png";